export class Status
{
    
    constructor(public id:number,public status:number)
    {
        
    }
}